import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "modal"
    ]

    static values = {
        preventDefault: Boolean
    }

    connect() {
        if (this.modalTarget.dataset.autoOpen === 'true') {
            this.open();
        }
    }

    open(event) {
        if (this.preventDefaultValue) {
            event.preventDefault();
        }
        $(this.modalTarget).modal('show');
    }


}
